
import { defineComponent, reactive, computed, toRaw, ref, watch } from 'vue';
import { getTimeDistance } from './util';

import AreaDeskTop from './components/area-desktop.vue';
import SalesCard from './components/sales-card.vue';

import { useAnalysisData } from '@/api/dashboard/analysis';
import {
  analyse_day_appointment,
  analyse_month_appointment,
  query_shop_list,
} from '@/api/mjstore-model.ts';
import { query_stat_by_shop_ids, query_graph_and_rank_by_shop_ids } from '@/api/mjstat-model.ts';
import moment, { Moment } from 'moment';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_JSC_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import { SearchConfig } from '@/components/page-model/typing';
import dayjs, { Dayjs } from 'dayjs';

import { useForm } from 'ant-design-vue/es/form';
export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();
    const value1 = ref<Dayjs>();
    const month = ref(moment().format('YYYY-MM'));
    const current_org = store.getters['user/current_org'];
    const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
    const jsc_data_list: any[] = ls.get(STORAGE_CURRENT_JSC_KEY) || []; //驾驶舱
    const activeKey = ref(1);
    const datasource = ref([]);
    const shop_list = ref([]);
    const shop_name = ref('');
    const types = ref('cz_price');
    const tabList = reactive({
      list: [],
      shop_ids: [],
      tag_type: '',
    });
    const visitData = reactive({
      loading: true,
      data: {},
    });
    const DataList = reactive({
      loading: true,
      list_cz: [],
      list_user: [],
    });
    const Ranklist = reactive({
      list_cz: [],
      list_user: [],
    });
    const loaded = ref(false);
    const get_data_list = (date: any, shop_ids: any, type: any, num: any, tag_type: any) => {
      if (num > 0) {
        analysisState.loading = true;
        query_graph_and_rank_by_shop_ids({
          org_id: current_org.id,
          shop_ids: shop_ids,
          query_type: type,
          tag_type: tag_type,
          date_interval: date,
          // top_leader: 1,
        })
          .then((res: any) => {
            DataList.list_cz = res.data.list;
            Ranklist.list_cz = res.ranks.map((item: any) => item);
            loaded.value = true;
          })
          .finally(() => {
            analysisState.loading = false;
          });
      }
    };

    const state = reactive({
      loading: true,
      salesLoading: true,
      activeKey: 'Stores 0',
      salesType: 'all',
      rangePickerValue: getTimeDistance('year'),
    });

    const { state: analysisState } = useAnalysisData();

    const salesPieData = computed(() => {
      const { salesTypeData, salesTypeDataOnline, salesTypeDataOffline } = analysisState.chartData;
      let salesPieData = [];
      if (state.salesType === 'all') {
        salesPieData = salesTypeData;
      } else {
        salesPieData = state.salesType === 'online' ? salesTypeDataOnline : salesTypeDataOffline;
      }
      return salesPieData;
    });

    const handleRangePickerChange = (rangePickerValue: [Moment, Moment]) => {
      state.rangePickerValue = rangePickerValue;
      const val = toRaw(state.rangePickerValue);
      get_data_list(
        [val[0].format('YYYY-MM-DD'), val[1].format('YYYY-MM-DD')],
        tabList.shop_ids,
        types.value,
        1,
        tabList.tag_type,
      );
    };

    const selectDate = (type: any) => {
      state.rangePickerValue = getTimeDistance(type);
      const val = toRaw(state.rangePickerValue);
      get_data_list(
        [val[0].format('YYYY-MM-DD'), val[1].format('YYYY-MM-DD')],
        tabList.shop_ids,
        types.value,
        1,
        tabList.tag_type,
      );
    };
    const isActive = (type: any) => {
      const value = getTimeDistance(type);
      if (!state.rangePickerValue[0] || !state.rangePickerValue[1]) {
        return '';
      }
      if (
        state.rangePickerValue[0].isSame(value[0], 'day') &&
        state.rangePickerValue[1].isSame(value[1], 'day')
      ) {
        return 'currentDate';
      }
      return '';
    };
    const getTypes = (type: any) => {
      types.value = type;
      const val = toRaw(state.rangePickerValue);
      get_data_list(
        [val[0].format('YYYY-MM-DD'), val[1].format('YYYY-MM-DD')],
        tabList.shop_ids,
        types.value,
        1,
        tabList.tag_type,
      );
    };
    const getTabs = (key: any) => {
      tabList.list.forEach((item: any) => {
        if (item.id == key) {
          tabList.shop_ids = item.shop_ids;
        }
      });
      const val = toRaw(state.rangePickerValue);
      get_data_list(
        [val[0].format('YYYY-MM-DD'), val[1].format('YYYY-MM-DD')],
        tabList.shop_ids,
        types.value,
        1,
        tabList.tag_type,
      );
    };

    const route = useRoute();
    const local_path = route.path;
    watch(
      () => route.path,
      () => {
        if (route.path == local_path) {
          init();
        }
      },
    );
    const search_config: SearchConfig = {
      settings: {
        labelAlign: 'right',
        layout: 'inline',
      },
      fields: [
        {
          type: 'monthpicker',
          name: 'check_date',
          label: '月份',
          disabled: false,
          allowClear: true,
          inputType: 'number',
          defaultValue: '',
          format: 'YYYY-MM',
          valueFormat: 'YYYY-MM-01',
          placeholder: '请选择月份',
        },
        {
          type: 'remoteselect',
          name: 'shop_id',
          label: '门店',
          disabled: false,
          placeholder: '请选择执行门店',
          datasourceType: 'remote',
          mode: 'default',
          allowClear: true,
          modalType: 'mjstore-shop',
        },
      ],
      rules: reactive({}),
      model: reactive({
        org_id: current_org?.id,
        check_date: dayjs().format('YYYY-MM-DD'),
        shop_id: current_shop?.id,
      }),
    };
    const search_options = {};
    const { resetFields, validateInfos } = useForm(search_config.model, search_config.rules);
    const onPanelChange = (date: any) => {
      search_config.model.check_date = date.format('YYYY-MM-DD');
      search();
    };
    const onSelect = (date: any) => {
      router.push({
        path:
          '/business_manage/profile/basic_order/' +
          search_config.model.shop_id +
          '/' +
          date.format('YYYY-MM-DD'),
      });
    };
    const search = () => {
      query_shop_list({
        org_id: current_org?.id,
        is_active: true,
        pageSize: 2000,
      }).then((res: any) => {
        shop_list.value = res.data;
        shop_list.value.map((item: any) => {
          if (search_config.model.shop_id == item.id) {
            shop_name.value = item.name;
          }
        });
      });
      value1.value = dayjs(search_config.model.check_date);
      month.value = moment(search_config.model.check_date).format('YYYY-MM');
      analyse_month_appointment({
        ...search_config.model,
      }).then((res: any) => {
        datasource.value = res.data;
      });
    };
    const getListData = (value: Moment) => {
      const Obj: any = {};
      datasource.value.map((temp: any) => {
        if (value.format('MM-DD') == moment(temp.time).format('MM-DD')) {
          Obj.order_num = temp.order_num;
          if (value.format('MM-DD') < moment().format('MM-DD')) {
            Obj.class = 'grey';
            Obj.no_order_num = temp.no_order_num;
            Obj.order_coming_num = temp.order_coming_num;
          } else if (value.format('MM-DD') == moment().format('MM-DD')) {
            Obj.class = 'border';
            Obj.no_order_num = temp.no_order_num;
            Obj.order_coming_num = temp.order_coming_num;
          } else {
            Obj.class = '';
            if (Obj.order_num == 0) {
              Obj.order_num = null;
            }
          }
        }
      });
      return Obj;
    };
    const init = () => {
      // 获取shop_ids
      const path_arr = local_path.split('/');
      const ls_index = path_arr[path_arr.length - 1];
      tabList.shop_ids = jsc_data_list[Number(ls_index.split('-')[1])].shop_ids;
      tabList.tag_type = jsc_data_list[Number(ls_index.split('-')[1])].tag_type;
      search_config.model.shop_id = tabList.shop_ids[0];
      search();
      visitData.loading = true;
      query_stat_by_shop_ids({
        org_id: current_org.id,
        shop_ids: tabList.shop_ids,
      }).then((res: any) => {
        visitData.loading = false;
        Object.assign(visitData.data, res);
        selectDate('month');
      });
      // get_stat_tag_list({
      //   org_id: current_org.id,
      // }).then((res: any) => {
      //   tabList.list = res;
      //   tabList.list.forEach((item: any) => {
      //     if(item.id == activeKey.value){
      //       tabList.shop_ids = item.shop_ids;
      //     }
      //   });
      //
      // });
    };
    init();

    const handleChangeSalesType = (e: any | Event) => {
      state.salesType = e.target.value;
    };

    const handleTabChange = (key: string) => {
      state.activeKey = key;
    };

    analysisState.loading = false;
    // fetchAllData();

    return {
      state,
      onSelect,
      onPanelChange,
      value1,
      search,
      analysisState,
      resetFields,
      validateInfos,
      search_config,
      search_options,
      salesPieData,
      visitData,
      DataList,
      Ranklist,
      tabList,
      activeKey,
      loaded,
      month,
      shop_name,
      // shopData,
      // shopDataList,

      getListData,
      isActive,
      getTabs,
      getTypes,
      selectDate,
      handleRangePickerChange,
      handleTabChange,
      handleChangeSalesType,
    };
  },
  components: {
    // IntroduceRow,
    SalesCard,
    // StaffDeskTop,
    // ShopDeskTop,
    // TopSearch,
    // ProportionSales,
    // OfflineData,
    AreaDeskTop,

    // icons
    // EllipsisOutlined,
  },
});
